/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, ElementRef, ChangeDetectorRef, AfterViewInit } from "@angular/core";
import { Logger, TranslateService } from "@html-core";
import { Localize } from "../../common/service/localize.service";

@Component({
   standalone: false,
   selector: "privacy-policy",
   template:
      '<a class="home-link" open-chrome-link id="privacyPolicyLink" ' +
      'href="https://www.omnissa.com/trust-center/#privacy-notices" target="_blank" rel="{{linkRelValue}}"></a>'
})
export class PrivacyLinkComponent implements AfterViewInit {
   public linkRelValue: string;
   private element;
   constructor(
      private translate: TranslateService,
      private localize: Localize,
      private _el: ElementRef,
      private changeDetector: ChangeDetectorRef
   ) {}

   ngAfterViewInit() {
      this.element = $(this._el.nativeElement.children[0]);
      this.localize.localeReady$.subscribe((ready) => {
         setTimeout(() => {
            if (ready) {
               const name = this.translate._T("privacy_policy");
               this.element.html(name);
            }
         });
      });

      this.linkRelValue = __REL_FOR_LINK__;
      this.changeDetector.detectChanges();
   }
}
